import styled, { keyframes, css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const BackgroundGradient = css`
  background: linear-gradient(
    90deg,
    #e7eef0 0%,
    #f3f7f8 23.66%,
    rgba(250, 251, 252, 0.489237) 45.78%,
    #f2f6f7 78.19%,
    #e7eef0 98.76%
  );
`;

const ShineLines = keyframes`
  0% { background-position: -200px };
  100% { background-position: 350px};
`;

export const animationLine = css`
  animation: ${ShineLines} 4s infinite linear;
`;

const LineContent = styled.div`
  height: ${({ height }) => height || '16px'};
  width: ${({ width }) => width || '100%'};
  border-radius: ${({ borderRadius }) => borderRadius || '8px'};
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  margin-right: ${({ marginRight }) => marginRight || '0px'};
  margin-left: ${({ marginLeft }) => marginLeft || '0px'};
  ${BackgroundGradient};
  ${animationLine};
`;

const TableContainer = styled.div`
  width: 100%;
`;

const Table = styled.table`
  width: 100%;
  border-radius: 8px;
  border-top-right-radius: 0 !important;
  border-top-left-radius: 0 !important;
  border: 1px solid ${select('middleGray')};
  border-collapse: none;
  border-spacing: 0px !important;
  thead,
  tbody tr {
    display: table;
  }
`;

const Thead = styled.thead`
  width: 94%;
  margin-left: 3%;
  height: 54px;
  border-radius: 7px 7px 0px 0px;
  border-bottom: 1px solid ${select('grayMedium')};
  tr td {
    padding-left: 2% !important;
    font-weight: 600;
    font-size: 14px;
    line-height: 18.2px;
    color: ${select('grayDarkLight')};
  }
  tr td:last-child {
    padding-left: 60px !important;
  }
`;

const Tbody = styled.tbody`
  width: 100%;
  display: block;
`;

const Tr = styled.tr`
  width: 100%;
  height: ${({ height }) => height || '68.5px'};
`;

const Td = styled.td`
  padding-left: 43px;
  label {
    margin-left: 28%;
  }
  width: 27%;
`;

const CustomLink = styled.a`
  color: ${select('black')};
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  pointer-events: none;
  cursor: pointer;
  margin-right: ${({ isMobile }) => (isMobile ? '0px' : '20px')};
  margin-left: ${({ device }) => (device === 'tablet' ? '80%' : '88%')};
  margin-bottom: 20px;
  > img {
    margin-left: 8px;
    transform: rotate(-90deg);
  }
`;

export { TableContainer, Table, Thead, Tbody, Tr, Td, LineContent, CustomLink };
